import { HomepageServerDisplaySchema, type HomepageImage, type HomepageSettings } from '@mcpanel/core';
import type { ServerView } from '../api/types';
import { HomepageImages } from './HomepageImages';

type Display = HomepageSettings['servers'][string];

/** サーバーごとに、公開ページでの名前・説明・入り方・写真を決める（保存は全体の「保存」で） */
export function HomepageServers({
  servers,
  settings,
  onChange,
  images,
  reloadImages,
}: {
  servers: ServerView[];
  settings: HomepageSettings;
  onChange: (servers: HomepageSettings['servers']) => void;
  images: HomepageImage[];
  reloadImages: () => void;
}) {
  const update = (id: string, patch: Partial<Display>) =>
    onChange({
      ...settings.servers,
      [id]: { ...HomepageServerDisplaySchema.parse(settings.servers[id] ?? {}), ...patch },
    });
  return (
    <div className="stack">
      <h3 data-search-id="homepage-servers">サーバーごとの表示</h3>
      <p className="small muted">
        ホームページに出るのは、ランチャーで公開しているサーバーだけです。空の欄はサーバーの名前・版などから自動で出します。
      </p>
      {servers.map((server) => {
        const display = HomepageServerDisplaySchema.parse(settings.servers[server.id] ?? {});
        const field = (key: 'title' | 'tagline' | 'joinHint', label: string, max: number, placeholder: string) => (
          <label className="field">
            {label}
            <input
              className="input"
              maxLength={max}
              placeholder={placeholder}
              value={display[key]}
              onChange={(e) => update(server.id, { [key]: e.target.value })}
            />
          </label>
        );
        return (
          <details key={server.id} className="card card-body stack">
            <summary>
              <strong>{display.title || server.name}</strong> <span className="small muted">（{server.id}）</span>
            </summary>
            {field('title', '表示する名前', 40, server.name)}
            {field(
              'tagline',
              'ひとこと（カードに出る。例: クリエイティブ）',
              40,
              `Minecraft ${server.software.mcVersion}`,
            )}
            <label className="field">
              説明
              <textarea
                className="input"
                maxLength={300}
                value={display.description}
                onChange={(e) => update(server.id, { description: e.target.value })}
              />
            </label>
            {field('joinHint', '入り方', 120, `Hub で /server ${server.id}`)}
            <label className="check">
              <input
                type="checkbox"
                checked={display.showBedrock}
                onChange={(e) => update(server.id, { showBedrock: e.target.checked })}
              />
              統合版のアドレスをトップに出す（統合版が有効なときだけ）
            </label>
            <HomepageImages target={`server:${server.id}`} label="写真" images={images} reload={reloadImages} />
          </details>
        );
      })}
    </div>
  );
}
